import {useWebView} from '@/common-pages/hooks/webview.hooks';
import React, {useState} from 'react';
import {useGameUrl} from './useGameUrl';
import Spin from '@/components/basic/spin';
import {useShare} from '@/common-pages/hooks/share.hooks';
import {useLatest} from '@/common-pages/hooks/useLatest';
import {PATH} from './const';
import {createGameMessageHandler} from './handleMessage';
function Share() {
  const [pageLoading, setPageLoading] = useState(true);
  const {url} = useGameUrl(PATH.invite);
  const {shareGame} = useShare();
  const latestShareGame = useLatest(shareGame);
  const {render} = useWebView({
    originUrl: url,
    onLoadEnd: () => {
      setPageLoading(false);
    },
    onMessage: createGameMessageHandler({
      onShare: () => latestShareGame.current(),
    }),
  });
  return (
    <div className="h-full w-full">
      <Spin loading={pageLoading} style={{width: '100%', height: '100%'}}>
        {render}
      </Spin>
    </div>
  );
}

export default Share;
